"use client";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTrigger,
} from "@/components/ui/dialog";
import Cal from "@calcom/embed-react";
import { DialogTitle } from "@radix-ui/react-dialog";

const CalModel = () => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="outline">Schedule Meeting</Button>
      </DialogTrigger>
      <DialogContent className="overflow-y-scroll">
        <DialogHeader>
          <DialogTitle>Schedule a Meeting</DialogTitle>
          {/* <DialogDescription>
            Make changes to your profile here. Click save when youre done.
          </DialogDescription> */}
        </DialogHeader>
        <Cal
          calLink="contact-digitalthrive.com.au/initial-consultation" // Your Cal.com username
          style={{ height: "60vh", width: "2" }}
          config={{
            layout: "month_view",
          }}
        />
        <DialogFooter></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CalModel;
